import { render } from "./ContactCommunicationDetail.vue?vue&type=template&id=410c611a&scoped=true"
import script from "./ContactCommunicationDetail.vue?vue&type=script&lang=js"
export * from "./ContactCommunicationDetail.vue?vue&type=script&lang=js"

import "./ContactCommunicationDetail.vue?vue&type=style&index=0&id=410c611a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410c611a"]])

export default __exports__